import type { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';

export function DropHintDivider() {
  return (
    <div className="flex items-center gap-2">
      <div className="border-primary h-px w-[5.5ch] border-t" />
      <Text variant="studio/body/medium/sm" className="text-gray-60 shrink-0">
        or
      </Text>
      <div className="border-primary h-px w-[5.5ch] border-t" />
    </div>
  );
}

export interface BatchReferenceEmptyDropzoneProps {
  onOpenLibrary: () => void;
  dropHint: ReactNode;
}

export default function BatchReferenceEmptyDropzone({
  onOpenLibrary,
  dropHint,
}: BatchReferenceEmptyDropzoneProps) {
  return (
    <div className="flex flex-col items-center gap-3 py-2">
      <Button
        variant="primary"
        size="sm"
        onClick={(event) => {
          event.stopPropagation();
          onOpenLibrary();
        }}
      >
        Add from your Library
      </Button>
      <DropHintDivider />
      {dropHint}
    </div>
  );
}
